var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-tabs',[_c('v-tabs-slider',{attrs:{"color":"secondary"}}),_c('v-tab',{staticClass:"text-none"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }